import axios from 'axios'

const filter = {
  namespaced: true,
  state: {
    //开关
    switch: false,
    filterscreenLoading: false,
    //筛选楼房选项源数据
    buildingAreas: [],
    //楼栋
    buildings: {},
    //楼层
    floors: {},
    //房间
    rooms: [],

    //筛选项目选项源数据
    projectCategories: [],
    //项目大类
    categorys: {},
    //项目明细
    details: [],
    //班次
    shifts: ['早班', '中班', '晚班'],
    //选中筛选数组
    selectDetails: [],
    selectRooms: [],
    activeShifts: [],
    shiftTimeList: [
      { beginTime: '06:30', endTime: '14:30' },
      { beginTime: '14:30', endTime: '22:30' },
      { beginTime: '22:30', endTime: '06:30' }
    ]
  },
  getters: {},
  mutations: {
    //更新选中值
    updateSelectVal(state, { type, arr }) {
      let array = ['selectRooms', 'selectDetails', 'activeShifts']
      state[array[type]] = arr
    },
    initFilter(state, { buildingAreas, projectCategories }) {
      let buildings = {},
        floors = {},
        _rooms = [],
        categorys = {},
        details = []
      for (let i = 0; i < buildingAreas.length; i++) {
        let building = buildingAreas[i]
        buildings[building.Name] = []
        for (let n = 0; n < building.Floors.length; n++) {
          let floor = building.Floors[n]
          let rooms = building.Floors[n].Rooms
          floors[floor.Name] = []
          _rooms = _rooms.concat(rooms)
          for (let m = 0; m < rooms.length; m++) {
            buildings[building.Name].push(rooms[m])
            floors[floor.Name].push(rooms[m])
          }
        }
      }
      for (let i = 0; i < projectCategories.length; i++) {
        let categorys_obj = projectCategories[i]
        categorys[categorys_obj.Name] = []
        for (let n = 0; n < categorys_obj.Items.length; n++) {
          let details_obj = categorys_obj.Items[n]
          categorys[categorys_obj.Name].push(details_obj.Name)
          details.push(details_obj.Name)
        }
      }
      state.buildingAreas = buildingAreas
      state.projectCategories = projectCategories
      state.buildings = buildings
      state.floors = floors
      state.rooms = _rooms
      state.categorys = categorys
      state.details = details
    }
  },
  actions: {
    //获取筛选器数据
    filterQuery({ state, commit, rootGetters }, data) {
      state.filterscreenLoading = true
      axios
        .post(`/Pad/FilterQuery?userId=${rootGetters.user.UserId}`, data)
        .then((res) => {
          let buildingAreas = res.data.obj.BuildingAreas,
            projectCategories = res.data.obj.ProjectCategories
          state.filterscreenLoading = false
          commit('initFilter', { buildingAreas, projectCategories })
          return res
        })
        .catch((err) => {
          state.filterscreenLoading = false
        })
    },
    //打开筛选列表
    openFilter({ dispatch, state }, val) {
      state.switch = val
      if (state.switch && (!state.buildingAreas.length || !state.buildingAreas.length)) {
        return dispatch('filterQuery')
      }
    }
  }
}

export default filter



// WEBPACK FOOTER //
// ./src/store/modules/filter.js